import { BoxProps, Flex, FlexProps, Text, TextProps } from '@chakra-ui/react'
import { getTokenByDenom } from '@/services/token-service'
import { SupportedCurrencies, TokenMoney } from '@ninjablaze/sdk-ts'
import { useFiatCurrencyStore } from '@/context/FiatCurrencyStore'

type CommonAmountProps = {
  currencyStyles?: TextProps
  amountStyles?: TextProps
  wrapperStyles?: FlexProps
  iconStyles?: TextProps

  iconSize?: BoxProps['boxSize']
  iconMono?: boolean
  iconHidden?: boolean
}
export type AmountProps = {
  value: string | React.ReactElement | TokenMoney
  denom?: string
} & CommonAmountProps

/**
 * Like Amount, but converts USDC values to the selected fiat currency when non-USD fiat is selected.
 */
export const FiatOrCryptoAmount = (props: AmountProps) => {
  const isUsd = useFiatCurrencyStore((s) => s.isUsd())
  const formatBalance = useFiatCurrencyStore((s) => s.formatBalance)

  const denom = props.value instanceof TokenMoney ? props.value.denom : props.denom
  const isUsdc = denom ? getTokenByDenom(denom)?.currency === SupportedCurrencies.USDC : false

  if (isUsdc && !isUsd) {
    let humanAmount: number
    if (props.value instanceof TokenMoney) {
      humanAmount = props.value.humanNumber
    } else if (typeof props.value === 'string') {
      humanAmount = parseFloat(props.value as string)
    } else {
      return <Amount {...props} />
    }

    if (!isNaN(humanAmount)) {
      return (
        <Flex alignItems={'center'} gap={1.5} {...props.wrapperStyles}>
          <Text whiteSpace={'nowrap'} fontWeight={700} {...props.amountStyles}>
            {formatBalance(humanAmount)}
          </Text>
        </Flex>
      )
    }
  }

  return <Amount {...props} />
}

export const Amount = ({
  value,
  denom,

  wrapperStyles,
  amountStyles,
  currencyStyles,
  iconStyles,

  iconSize,
  iconMono,
  iconHidden,
}: AmountProps) => {
  let textValue = value instanceof TokenMoney ? value.humanFormat : value
  const token = getTokenByDenom(value instanceof TokenMoney ? value.denom : denom!)

  return (
    <Flex alignItems={'center'} gap={1.5} {...wrapperStyles}>
      {!iconHidden && (
        <Text as={'span'} {...iconStyles} h={iconSize || 4} w={iconSize || 4}>
          {iconMono ? token?.iconMono(iconSize) : token?.icon(iconSize)}
        </Text>
      )}
      <Text whiteSpace={'nowrap'} fontWeight={700}>
        <Text as="span" {...amountStyles}>
          {textValue}{' '}
        </Text>
        <Text as="span" color={'ninja.300'} {...currencyStyles}>
          {token?.name}
        </Text>
      </Text>
    </Flex>
  )
}
